export default __webpack_public_path__ + "static/ray-white-2-14effaafc6f77ed9b4bd80b5e69ca295.png";